module.exports = __webpack_public_path__ + "img/expostyle_1251_citronelle_green_pantone381c.527b3ad3.jpg";